import React, { useState } from 'react'
import { FaTimesCircle } from 'react-icons/fa'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
import { useSelector } from 'react-redux'

import { useStateContext } from '../../../state/context'
import { setBedSpace, } from '../../../state/actions/actions'
import { deleteBedSpace } from '../../../state/actions/admin.actions'


const DeleteBedSpaceModal = (props) => {
    const dispatch = useDispatch();

    const { modals, setModals } = useStateContext()

    const { bedspace_update } = useSelector((state) => state.root);

    const handleSubmit = (e) => {
        e.preventDefault()

        dispatch(deleteBedSpace({ id: bedspace_update?.id, toast, setModals: setModals, modals: modals }));
        setTimeout(() => {
            dispatch(setBedSpace({ data: null }))
        }, 2000)
    }
    return (
        <div className="fixed grid h-screen w-full z-10 bg-[#11111180] place-items-center">
            <div className="bg-white w-[500px] rounded px-[30px] py-[20px]">
                <div className="flex flex-col space-y-5">
                    <div className="flex justify-between items-center">
                        <h4 className='text-dark-green text-[20px] font-bold'>Delete</h4>
                        <FaTimesCircle
                            className='text-dark-yellow cursor-pointer'
                            onClick={() => {
                                dispatch(setBedSpace({ data: null }))
                                setModals({ ...modals, showDeleteBedSpaceModal: !modals.showDeleteBedSpaceModal })
                            }}
                            size={20}
                        />
                    </div>

                    <form onSubmit={handleSubmit}>
                        <p className="text-left">Are you sure you want to delete bedspace <span className='font-bold italic'>{bedspace_update?.bed_number}</span> in ward <span className='font-bold italic'>{bedspace_update?.ward.name}</span>?</p>

                        <div className='mt-4 flex justify-end'>
                            <button
                                type='submit'
                                className="inline-block w-[175px] px-6 py-2.5 bg-dark-yellow text-white font-medium text-xs leading-tight rounded shadow-md hover:scale-90 transition duration-500 ease"
                            >Delete</button>
                        </div>
                    </form>
                </div>


            </div>
        </div>
    )
}

export default DeleteBedSpaceModal